var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DialogLayout", {
    staticClass: "detail-search-dialog",
    attrs: { title: "詳細検索", visible: _vm.dialogVisible, width: "65em" },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      open: _vm.open
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function() {
          return [
            _c("MergeDataForm", {
              ref: "mergeDataForm",
              attrs: {
                "label-width": "10em",
                formMode: "search",
                "autocomplete-registration-symbol-set":
                  _vm.autocompleteRegistrationSymbolSet,
                "autocomplete-model-code-set": _vm.autocompleteModelCodeSet,
                "autocomplete-customer-code-set":
                  _vm.autocompleteCustomerCodeSet,
                "autocomplete-airport-code-set": _vm.autocompleteAirportCodeSet
              },
              model: {
                value: _vm.mergeDataForm,
                callback: function($$v) {
                  _vm.mergeDataForm = $$v
                },
                expression: "mergeDataForm"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("SearchDialogFooter", {
              on: { clear: _vm.clickClear, search: _vm.clickSearch }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }